const identity = (s) => s;
const titleCaseWords = (s) => s.replace(/\b\w/g, (c) => c.toUpperCase());
function legacyUsdOwnerRole(ownerType) {
    switch (ownerType) {
        case 'shop': return 'Shop';
        case 'agent': return 'Agent';
        case 'super_agent': return 'Super agent';
        case 'player': return 'Player';
        case 'platform': return 'Platform';
        default: return ownerType ? titleCaseWords(ownerType.replace(/_/g, ' ')) : 'Account';
    }
}
/** Production wording (8ad4e31). Admin renders these because it mounts no TermsProvider (spec §4.2). */
export const LEGACY_TERMS = {
    variant: 'legacy',
    applyFilters: 'Apply Filter',
    cash: {
        ledgerTitle: 'Cash Transactions',
        ledgerDescription: 'History of cash credit sales in the hierarchy.',
        flowLabel: {
            admin_super_agent: 'Admin → Super Agent',
            super_agent_agent: 'Super Agent → Agent',
            agent_shop: 'Agent → Shop',
            shop_player_deposit: 'Shop → Player (Deposit)',
            shop_player_redemption: 'Player → Shop (Redemption)',
        },
        flowShortLabel: {
            admin_super_agent: 'Admin → SA',
            super_agent_agent: 'SA → Agent',
            agent_shop: 'Agent → Shop',
            shop_player_deposit: 'Counter deposit',
            shop_player_redemption: 'Counter redemption',
        },
        flowFilterOptions: [
            { value: '', label: 'All' },
            { value: 'admin_super_agent', label: 'Admin → Super Agent' },
            { value: 'super_agent_agent', label: 'Super Agent → Agent' },
            { value: 'agent_shop', label: 'Agent → Shop' },
            { value: 'shop_player_deposit', label: 'Shop → Player (Deposit)' },
            { value: 'shop_player_redemption', label: 'Player → Shop (Redemption)' },
        ],
        fromColumn: 'Seller',
        toColumn: 'Buyer',
        searchPlaceholder: 'Transaction ID, buyer, reference…',
        counterInTitle: 'Counter Cash In',
        counterOutTitle: 'Counter Cash Out',
        creditWalletSuffix: 'CDN wallet',
        sellTitle: { counter: 'Deposit credits (cash)', hierarchy: 'Sell credits (cash)' },
        sellSubtitleHierarchy: 'Buyer is pre-filled from entity detail.',
        sellSubmit: { counter: 'Record & credit', hierarchy: 'Record & credit' },
        sellCreditsField: 'Credits to sell *',
        sellBuyerBadge: 'Buyer',
        sellInvalidCostRate: 'Buyer cost rate is invalid',
        redeemTitle: 'Redeem credits (cash)',
        redeemSubmit: 'Record & redeem',
    },
    credit: {
        typeFilterOptions: [
            { value: 'all', label: 'All' },
            { value: 'deposit', label: 'Deposit' },
            { value: 'withdraw', label: 'Withdraw' },
        ],
        summary: { total: 'Total Transactions', in: 'Total Deposits', out: 'Total Withdrawals', net: 'Net Flow' },
        emptyFilteredHint: 'Try changing your filters or search, then click Apply Filter.',
        partyRole: (roleNoun) => titleCaseWords(roleNoun),
        partyText: identity,
        typeDisplay: identity,
    },
    usd: {
        typeFilterOptions: [
            { value: 'all', label: 'All types' },
            { value: 'deposit', label: 'Deposit' },
            { value: 'withdrawal', label: 'Withdrawal' },
            { value: 'purchase_credits', label: 'Purchase credits' },
            { value: 'adjustment', label: 'Adjustment' },
            { value: 'reversal', label: 'Reversal' },
        ],
        summary: { total: 'Total Transactions', in: 'Total Deposits', out: 'Total Withdrawals', net: 'Net Flow' },
        ownerRole: legacyUsdOwnerRole,
        activityText: identity,
        typeDisplay: identity,
        partyText: identity,
    },
};
